import { type ButtonHTMLAttributes, type ReactNode } from 'react';

interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  selected?: boolean;
}

export function Chip({ children, selected = false, className = '', type = 'button', ...rest }: ChipProps) {
  const classes = `chip${selected ? ' chip--active' : ''}${className ? ` ${className}` : ''}`;
  return (
    <button type={type} className={classes} aria-pressed={selected} {...rest}>
      {children}
    </button>
  );
}
